/* eslint-disable */
import 'jquery.cookie';
import ls from 'local-storage';
import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';
import '@/css/desktop/search/search.scss'
import '@/css/desktop/search/newSearchHeader.scss'
import AbstractSearchController from '@/js/desktop/Domain/Abstract/SearchController';
import SearchPageView from '@/js/desktop/View/SearchPage';
import topMenuFormFixed from "@/js/desktop/components/fixedForm/fixedForm";

var openCalendarIfDirectSearchCall = !!_.isUndefined($.cookie('requestFromMainPage'));

var Controller = AbstractSearchController.extend({
	initModels: function () {
		console.time('init');
		this.initSearchForm();
		this.model = this.searchFormView.model;
		let SearchPageViewWithoutDataLayerEvents = SearchPageView.extend({
			dataLayerEvents: function () {}
		});
		this.view = new SearchPageViewWithoutDataLayerEvents({
			el: '#forSearchView',
			dataLayerAnalytics: this.dataLayerAnalytics,
			searchFormViewModel: this.model,
			withoutStatic: true
		});
		topMenuFormFixed.initialize();
	},
	getAdditionalData: function () {
		var tourCriteriaFromLocalStorage;

		tourCriteriaFromLocalStorage = ls.get('tourCriteria');

		return tourCriteriaFromLocalStorage ? tourCriteriaFromLocalStorage : {};
	},
	syncHotelsChanged: function (model, syncHotels) {
		var self = this;
		if (openCalendarIfDirectSearchCall && syncHotels && syncHotels.length) {
			setTimeout(function () {
				var tourPeriod = self.model.get('tourPeriod');
				if (!tourPeriod) return;
				tourPeriod.get('view').viewModel.set('calendarOpened', true);
				$('.touristGroup.open').removeClass('open');
			}, 5000);
			openCalendarIfDirectSearchCall = false;
		}
	},
	initControllerModelEvents: function () {
		this.view.model.on('change:syncHotels', $.proxy(this.syncHotelsChanged, this));
	},

	initialize: function () {
		AbstractSearchController.prototype.initialize.call(this);
		this.initControllerModelEvents();
	}
});

$(() => {
	new Controller({
		el: 'body'
	});
});
